import {Component, Input, OnInit} from '@angular/core';
import {environment} from '@env';
import {Utils} from '@core/utils/utils';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {BaseResponse} from '@core/models/base-response.model';
import * as FileSaver from 'file-saver';
import {NotificationService} from '@shared/services/notification.service';

@Component({
  selector: 'app-download-file-confirm',
  templateUrl: './download-file-confirm.component.html',
  styleUrls: ['./download-file-confirm.component.css']
})
export class DownloadFileConfirmComponent implements OnInit {
  @Input()  downloadUrl: string;
  @Input() fileName;
  @Input() popupTitle: string = "Tải file về máy";
  @Input() popupPlacement: 'top' | 'left' | 'right' | 'bottom' | 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight' | 'leftTop' | 'leftBottom' | 'rightTop' | 'rightBottom' = 'topLeft';
  @Input() condition: boolean = false;

  constructor(private httpClient: HttpClient,
              private notiService: NotificationService) { }

  ngOnInit(): void {
    if (this.downloadUrl) {
      this.downloadUrl = environment.backend.baseUrl + (this.downloadUrl.startsWith('/') ? this.downloadUrl : '/' + this.downloadUrl);
    }

    if (Utils.isUnKnownValue(this.fileName)) {
      const extension = this.downloadUrl.split(".").pop();
      this.fileName = !Utils.isUnKnownValue(extension) ? (new Date().getTime().toString() + "." + extension) : new Date().getTime().toString();
    }
  }

  async download() {
    const blob = await this.getBlobFile(this.downloadUrl);
    if (blob)
      await FileSaver.saveAs(blob, this.fileName);
  }

  async getBlobFile(downloadUrl: string): Promise<Blob> {
    const token = localStorage.getItem('token');
    const headers = new HttpHeaders({'Authorization': 'Bearer ' + token});
    let blob = null;
    await this.httpClient.get(downloadUrl, {headers, responseType: 'blob'}).toPromise().then(res=> blob = res).catch(error => this.notiService.error(BaseResponse.getMessage(error)));
    return blob;
  }
}
